import React, { forwardRef, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Slider from 'react-slick';
import Reminders from './Reminders';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { leftArrow, rightArrow } from "../../../constants/icons";
import { getAllReminders } from '../../../../api/afterLogin/reminder';
import { convertUTCtoLocalTime } from '../../../../helpers/datetime_helper';
import { addDays, format } from "date-fns";
import { getSPAuthTokens } from '../../../../helpers/spauth_token_helper';

const RemindersSlider = forwardRef(({ onSlideChange, onTotalSlidesUpdate }, ref) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAtStart, setIsAtStart] = useState(true);
  const [isAtEnd, setIsAtEnd] = useState(false);
  const configData = useSelector((state) => state.config);
  const adminData = useSelector((state) => state.admin);
  const paths = useSelector((state) => state.user.paths);
  const learnerId    = configData?.session?.id ?? 0;
  const [allReminders, setAllReminders] = useState([]);
  const [hasReminders, setHasReminders] = useState(false);

  const timeZone = adminData?.us_timezone;
  
  const fetchAllReminder = async (accessToken) => {
    const params = {
      host        : `https://${configData.idp}/`,
      accessToken : accessToken, 
      uuid        : configData?.user_uuid,
      startDate   : adminData?.us_timezone ? format(convertUTCtoLocalTime(new Date(), adminData?.us_timezone), "yyyy-MM-dd") : format(new Date(), "yyyy-MM-dd"),
      endDate     : adminData?.us_timezone ?format(addDays(convertUTCtoLocalTime(new Date(), adminData?.us_timezone), 30), "yyyy-MM-dd") : format(new Date(), "yyyy-MM-dd")
    };
    try {
      const allFetchedReminders = await getAllReminders(params);
      if (allFetchedReminders && allFetchedReminders?.data && allFetchedReminders?.data?.length > 0) 
      {
        setAllReminders(allFetchedReminders.data);
        setHasReminders(true);
      }
    } catch (error) {
      console.error('Error fetching reminders:', error);
    }
  };

  const allRemindersData = allReminders && allReminders.map((reminder) => {
    let startDate     = convertUTCtoLocalTime(reminder.start_date, timeZone);
    let endDate       = convertUTCtoLocalTime(reminder.end_date, timeZone);
    let startTime     = format(new Date(startDate), "hh:mm a")
    let endTime       = format(new Date(endDate), "hh:mm a")
    let reminderImage = reminder.reminder_image;
    let host          = window.location.protocol + '//' +window.location.host;
    let currentUrl    = window.location.href;
    let launch_url    = reminder.launch_url;
    if(reminder.reminder_type === 'assignment'){
      launch_url = `${host}/materials/course/${reminder.reminder_course_id}/${reminder.reminder_id}/?callback=${currentUrl}`;
    }
    return {
      defaultImg: reminder?.reminder_type === 'live' ? paths.default_event :
                  reminder?.reminder_type === 'assignment' ? 'https://d2cl07xv2ii8xi.cloudfront.net/uploads/default/course/default-lecture.jpg' : 
                  reminder?.reminder_type === 'Deadlines' ? paths.default_course : paths.default_course,
      imgSrc: reminderImage,
      time: `${startTime} - ${endTime}`,
      dateReminder: format(new Date(startDate), "MMM dd, yyyy"),
      description: reminder.reminder_name,
      viewDetailsLink: launch_url,
      type: reminder.reminder_type
    }
  });

  const remindersData = [...allRemindersData];
  
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    afterChange: (current) => {
      setCurrentSlide(current);
      setIsAtStart(current === 0);
      setIsAtEnd(current === remindersData.length - 1);
      onSlideChange(current);
    },
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: 'unslick',
      },
    ],
  };

  useEffect(() => {
    if (learnerId) {
      const fetchTokenData = async () => {
        const tokenData = await getSPAuthTokens('mykademy', configData.access_token);
        if (tokenData) {
          fetchAllReminder(tokenData);
        }
      };
      fetchTokenData();
    }
  }, [])

  useEffect(() => {
    onTotalSlidesUpdate?.(remindersData.length);
  }, [remindersData.length, onTotalSlidesUpdate]);

  const handleNextSlide = () => {
    ref.current.slickNext();
  };

  const handlePrevSlide = () => {
    ref.current.slickPrev();
  };

  return (
    <>
      {hasReminders ===  true && (
      <div className="reminders-wrapper">
        <Slider
          ref={ref}
          {...settings}
          className="reminders-slider"
        >
          {remindersData.map((reminder, index) => (
            <div key={index}>
              <Reminders
                defaultImg={reminder.defaultImg}
                imgSrc={reminder.imgSrc}
                reminderTime={reminder.time}
                reminderDate={reminder.dateReminder}
                description={reminder.description}
                viewDetailsLink={reminder.viewDetailsLink}
                type={reminder.type}
              />
            </div>
          ))}
        </Slider>
        <div className="myk__reminder-actions">
          <div className="myk__reminder-slider-counter">
            <strong>{currentSlide + 1}</strong> / {remindersData.length}
          </div>
          <div className="myk_stu-carousel-action">
            <a href="#" className={`btn-move btn-prev ${isAtStart ? 'disabled' : ''}`} onClick={handlePrevSlide}>
              {leftArrow}
            </a>
            <a href="#" className={`btn-move btn-btn-next ${isAtEnd ? 'disabled' : ''}`} onClick={handleNextSlide}>
              {rightArrow}
            </a>
          </div>
        </div>
      </div>
      )}
    </>
  );
});

export default RemindersSlider;
